module.exports = __webpack_public_path__ + "img/oxford.56da2489.webp";